import { render } from "./doingThings.vue?vue&type=template&id=52a83e06&scoped=true"
import script from "./doingThings.vue?vue&type=script&lang=js"
export * from "./doingThings.vue?vue&type=script&lang=js"

import "./doingThings.vue?vue&type=style&index=0&id=52a83e06&lang=scss&scoped=true"
import "./doingThings.vue?vue&type=style&index=1&id=52a83e06&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a83e06"]])

export default __exports__